/**
 * OnboardingProgress — Step indicator dots for onboarding flow.
 */
import { View, StyleSheet } from 'react-native';
import { useTheme } from '@/contexts/ThemeContext';

const TOTAL_STEPS = 5;

interface Props {
  /** Current step (1-indexed) */
  step: number;
}

export default function OnboardingProgress({ step }: Props) {
  const { theme } = useTheme();
  const c = theme.colors;

  return (
    <View style={styles.container}>
      {Array.from({ length: TOTAL_STEPS }, (_, i) => {
        const stepNum = i + 1;
        const isActive = stepNum === step;
        const isComplete = stepNum < step;

        return (
          <View
            key={i}
            style={[
              styles.dot,
              {
                backgroundColor: isActive
                  ? c.accent
                  : isComplete
                  ? c.accent
                  : c.surface,
                opacity: isActive ? 1 : isComplete ? 0.5 : 0.3,
                width: isActive ? 24 : 8,
              },
            ]}
          />
        );
      })}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    paddingVertical: 16,
  },
  dot: {
    height: 8,
    borderRadius: 4,
  },
});
